module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.isLoaded) ? _c('div', {
    staticClass: "content-transition"
  }, [_c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('h1', {
    staticClass: "m-n font-thin h3"
  }, [_vm._v("Solicitar Remoção")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('router-link', {
    staticClass: "pull-right hidden-print",
    staticStyle: {
      "clear": "left"
    },
    attrs: {
      "to": {
        name: 'documentos'
      }
    }
  }, [_c('strong', {
    staticClass: "label no-radius bg-info"
  }, [_vm._v("Voltar")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('form', {
    staticClass: "bs-example form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("Origem")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('u-button-group', {
    staticClass: "pull-left m-r",
    attrs: {
      "options": _vm.tiposLocations
    },
    model: {
      value: (_vm.current_tp_location),
      callback: function($$v) {
        _vm.current_tp_location = $$v
      },
      expression: "current_tp_location"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("Destino")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.adress),
      expression: "data.adress"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "",
      "name": "adress",
      "required": ""
    },
    domProps: {
      "value": (_vm.data.adress)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "adress", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('u-button', {
    staticClass: "btn m-b-xs w-xs m-r-xs btn-info btn-search",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Pesquisar")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row wrapper-md"
  }, [_c('div', {
    staticClass: "map",
    attrs: {
      "id": "map"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row wrapper-md"
  }, [_c('div', {
    staticClass: "col-sm-2 label-info"
  }, [_c('span', [_vm._v("Deslocamento Ida :")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('span', [_vm._v(_vm._s(_vm.kmIda) + " / " + _vm._s(_vm.timeIda))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 label-info"
  }, [_c('span', [_vm._v("Deslocamento Volta :")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('span', [_vm._v(_vm._s(_vm.kmVolta) + " / " + _vm._s(_vm.timeVolta))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 label-info"
  }, [_c('span', [_vm._v("Deslocamento Total :")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('span', [_vm._v(_vm._s(_vm.kmTotal) + " / " + _vm._s(_vm.timeTotal))])])]), _vm._v(" "), _c('div', {
    staticClass: "row wrapper-md"
  })])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b3d1c00","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/solicitacao-remocao/components/Solicitar.vue
// module id = 1533
// module chunks = 17